// to modify config vars see: /config

import local from "./config/local.js";
import staging from "./config/staging.js";
import prod from "./config/prod.js";

let returnSet = prod; // by default return prod vars
if (process.env.NODE_ENV === "development") returnSet = local; // local
if (process.env.NODE_ENV === "staging" || process.env.REACT_APP_IS_STAGING) returnSet = staging; // dev env

export default returnSet;
